import React from "react";
import { FormBuilder } from "../../../../../components/form/FormBuilder";
import { FormComponent } from "../../../../../shared/utils/enums";
import { Medication } from "../../../../../interfaces/screens/content/patientDetails";
import dayjs from "dayjs";
import { medicationFormSchema } from "../../../../../shared/static/forms/patients/medicationForm";

interface MedicationFormProps {
  onSubmit: (data: any) => void;
  onCancel: () => void;
  medications: { label: string; value: string }[];
  initialValues?: Partial<Medication>;
  patientId: number;
}

export const MedicationForm: React.FC<MedicationFormProps> = ({
  onSubmit,
  onCancel: _onCancel,
  medications,
  initialValues,
  patientId: _patientId,
}) => {
  // Find the matching medication option for the initial value
  const initialMedication = initialValues?.name
    ? medications.find((med) => med.label === initialValues.name)?.value
    : "";

  // Update the schema with the provided medications
  const _schema = {
    ...medicationFormSchema,
    properties: {
      ...medicationFormSchema.properties,
      name: {
        ...medicationFormSchema.properties.name,
        componentProps: {
          ...medicationFormSchema.properties.name.componentProps,
          options: medications,
        },
      },
    },
  };

  // Format initial values for the form
  const formattedInitialValues = {
    name: initialMedication,
    dosage: initialValues?.dosage || "",
    frequency: initialValues?.frequency || "",
    startDate: initialValues?.startDate ? dayjs(initialValues.startDate) : null,
    notes: initialValues?.notes || "",
  };

  const handleSubmit = async (values: Record<string, any>) => {
    values.name = values.name;
    values.start_date = values.startDate.format("YYYY-MM-DD");
    values.end_date = values.endDate ? values.endDate.format("YYYY-MM-DD") : null;
    onSubmit(values);
  };

  return (
    <div className="py-4">
      <FormBuilder
        schema={_schema}
        onSubmit={handleSubmit}
        initialValues={formattedInitialValues}
        className="space-y-4"
      />
    </div>
  );
};
